import { StageTools } from '../types';

export const LAUNCH_EXPERIMENT_TOOLS: StageTools = [
  {
    category: "内测管理",
    tools: [
      {
        name: "TestFlight",
        icon: "",
        description: "iOS应用内测分发平台",
        url: "https://developer.apple.com/testflight/",
        tags: ["内测分发", "iOS"]
      },
      {
        name: "蒲公英",
        icon: "",
        description: "移动应用内测平台",
        url: "https://www.pgyer.com",
        tags: ["应用分发", "内测管理"]
      }
    ]
  },
  {
    category: "推广渠道",
    tools: [
      {
        name: "Product Hunt",
        icon: "",
        description: "全球最大的产品发布平台",
        url: "https://www.producthunt.com",
        tags: ["产品发布", "用户获取"]
      },
      {
        name: "少数派",
        icon: "",
        description: "科技媒体和产品推广平台",
        url: "https://sspai.com",
        tags: ["产品推广", "内容营销"]
      }
    ]
  },
  {
    category: "数据分析",
    tools: [
      {
        name: "Google Analytics",
        icon: "",
        description: "网站访问数据分析工具",
        url: "https://analytics.google.com",
        tags: ["数据分析", "用户行为"]
      },
      {
        name: "百度统计",
        icon: "",
        description: "免费的网站流量分析工具",
        url: "https://tongji.baidu.com",
        tags: ["流量分析", "数据统计"]
      }
    ]
  }
]; 